module.exports = __webpack_public_path__ + "img/xianlai_logo.523c1199.png";